// extracted by mini-css-extract-plugin
module.exports = {"body":"GateModal_body__O_oTu","button":"GateModal_button__2ivpd","description":"GateModal_description__1M8IO"};